import { MantineProviderProps } from '@mantine/core'

import { resolver } from './resolver'

export const mantineProviderConfig: MantineProviderProps = {
  defaultColorScheme: 'light',
  cssVariablesResolver: resolver,
}
